"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});

exports.default = function (value, params) {
  return params[0] + "\u4EE5\u4E0A\u3067\u5165\u529B\u3057\u3066\u304F\u3060\u3055\u3044";
};